import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export default function IconSettings({
    width = '16',
    height = '16',
    className = '',
    ...rest
}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            className={classnames(css.main, css.colored, className)}
            {...rest}
        >
            <path
                fillRule="evenodd"
                d="M10.731 1.955c.181.3.506.484.857.484h2.19c.357 0 .687.191.866.5l1.061 1.839a.998.998 0 01-.009 1.015l-1.017 1.691a1.001 1.001 0 000 1.032l1.017 1.691c.188.311.191.7.009 1.015l-1.061 1.839c-.179.309-.509.5-.866.5h-2.19c-.351 0-.676.184-.857.484l-.851 1.414a1 1 0 01-.857.485H6.977a1 1 0 01-.857-.485l-.851-1.414a1.001 1.001 0 00-.857-.484h-2.19c-.357 0-.687-.191-.866-.5L.295 11.222a.998.998 0 01.009-1.015l1.017-1.691a1.001 1.001 0 000-1.032L.304 5.793a.998.998 0 01-.009-1.015l1.061-1.839c.179-.309.509-.5.866-.5h2.19c.351 0 .676-.184.857-.484L6.12.541a1 1 0 01.857-.485h2.046a1 1 0 01.857.485l.851 1.414zM8 5a3.001 3.001 0 010 6 3.001 3.001 0 010-6z"
            />
        </svg>
    );
}
